import { createAction } from '@ngrx/store';
import { SiteFormModel } from '@spog-ui/shared/models/sites';

export const enterAction = createAction('[Admin / Add Site Page] Enter');

export const addSiteAction = createAction(
  '[Admin / Add Site Page] Add Site',
  (site: SiteFormModel) => ({ site }),
);
